import React, { useState } from "react";
import "./navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setMenuOpen(false);
  };

  const goHome = () => {
    scrollToSection("home");
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        {/* LOGO */}
        <div
          className="logo nav-item"
          onClick={goHome}
          style={{ cursor: "pointer" }}
        >
          <img
            src="/images/logo.png"
            alt="Pristine Kyra"
            className="navbar-logo"
          />
        </div>

        {/* HAMBURGER */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV LINKS */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>

          <li onClick={() => scrollToSection("home")}>
            Home
          </li>

          <li onClick={() => scrollToSection("about")}>
            About Us
          </li>

          <li onClick={() => scrollToSection("amenities")}>
            Amenities
          </li>

          <li onClick={() => scrollToSection("highlights")}>
            Highlights
          </li>

          <li onClick={() => scrollToSection("contact")}>
            Contact Us
          </li>

        </ul>

        {/* CTA BUTTON */}
        <div className="nav-cta">
          <button onClick={() => scrollToSection("contact")}>
            Get Quote
          </button>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;